import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Result from "../../Core/Result";
import TerriaError from "../../Core/TerriaError";
import Trait from "../Trait";
export default function primitiveArrayTrait(options) {
  return function (target, propertyKey) {
    const constructor = target.constructor;
    if (!constructor.traits) {
      constructor.traits = {};
    }
    constructor.traits[propertyKey] = new PrimitiveArrayTrait(propertyKey, options, constructor);
  };
}
export class PrimitiveArrayTrait extends Trait {
  constructor(id, options, parent) {
    super(id, options, parent);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "isNullable", void 0);
    this.type = options.type;
    this.isNullable = options.isNullable || false;
  }
  getValue(model) {
    const strataTopToBottom = model.strataTopToBottom;
    for (const stratum of strataTopToBottom.values()) {
      const value = stratum[this.id];
      if (value !== undefined) {
        return value;
      }
    }
    return undefined;
  }
  fromJson(_model, _stratumName, jsonValue) {
    if (!this.isValidJson(jsonValue)) {
      return Result.error(new TerriaError({
        title: "Invalid property",
        message: "Property ".concat(this.id, " is expected to be of type ").concat(this.type, "[].")
      }));
    }
    return new Result(jsonValue);
  }
  toJson(value) {
    return value;
  }
  isSameType(trait) {
    return trait instanceof PrimitiveArrayTrait && trait.type === this.type && trait.isNullable === this.isNullable;
  }
  isValidJson(jsonValue) {
    if (jsonValue === null && this.isNullable) {
      return true;
    }
    if (!Array.isArray(jsonValue)) {
      return false;
    }
    return jsonValue.every(item => typeof item === this.type);
  }
}